import { getClassNames } from '@websolutespa/bom-core';
import { LlmBlock, LlmChunkActionGroup } from '../../../types';
import { Action } from '../Action/action';

export const ActionGroup: React.FC<LlmBlock<LlmChunkActionGroup>> = (props) => {
  const { item } = props;
  const classNames = getClassNames('llm__actions');
  return (
    <div className={classNames}>
      {item.items.map((item, i) => (
        <Action key={i} {...props} item={item} />
      ))}
    </div>
  );
};

